import { render, staticRenderFns } from "./ProductionTableCard.vue?vue&type=template&id=4ae231c3&"
import script from "./ProductionTableCard.vue?vue&type=script&lang=js&"
export * from "./ProductionTableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports